module.exports = __webpack_public_path__ + "static/assets/d6a94ff2162f81eaa5a72606cefbdbd3.svg";